mobileSize = 1079;

$(document).ready(function(){ 
  // Check Window Size
  const windowSize = $(window).width();

  if (windowSize < 1080) {
    $('body')
      .addClass('saffireMobileSize')
      .removeClass('saffireLargeSize');
  } if (windowSize > 1079) {
    $('body').removeClass('saffireMobileSize');
  }
  
  // General Message
  $('.generalmessage').prependTo('header');

  // Replace Saffire Logo
	$('.saffire_logo').attr('src', `${FULLCLIENTTHEMEPATH}images/saffire.png`);
	

});

$(window).load(function(){
	$(".saffireMobileSize .header-logo").clone().prependTo(".mobile-menu-container .mobile-menu-header");
	$('body').addClass('pageIsLoaded');  
  	$('.saffireMobileSize #cardWidgetEmail .button').appendTo('.saffireMobileSize #cardWidgetEmail .card-content'); 	
	$(".featureLineup-text").text(function(){
		return $(this).text().length > 130 ? $(this).text().substr(0, 130)+'...' : $(this).text();
	});

  
  // Seo not active
  if ($('#seoWidget .card-widget-item').length === 0) {
	$('.saffireLargeSize .seo-main-outer .container').addClass("seo-inactive");
};

});

$(window).resize(function() {
  $('.saffireMobileSize #cardWidgetEmail .button').appendTo('.saffireMobileSize #cardWidgetEmail .card-content');
});

